import { render, staticRenderFns } from "./DetailProductMufle.vue?vue&type=template&id=a28a0c5c&"
import script from "./DetailProductMufle.vue?vue&type=script&lang=js&"
export * from "./DetailProductMufle.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductMufle.vue?vue&type=style&index=0&id=a28a0c5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports